<template lang="pug">
#ranking-categoria
    .bloco-tabs
        el-tabs.bloco-tabs-dimensao(tab-position='left', @tab-click='tabClick')
            el-tab-pane
                span.bloco-tabs-dimensao-menu(slot='label')
                    el-tooltip(
                        effect='dark',
                        placement='right',
                        content='Imóveis'
                    )
                        i.mdi.mdi-map-outline.mdi-flip-v

                .bloco-tabs-conteudo
                    h2 CAR
                    GraficoBarra(:dados='dadosImoveis', :key='idGrafico')

            el-tab-pane
                span.bloco-tabs-dimensao-menu(slot='label')
                    el-tooltip(
                        effect='dark',
                        placement='right',
                        content='Não conformidades Socioambientais'
                    )
                        i.mdi.mdi-alert-outline

                .bloco-tabs-conteudo
                    h2 Pessoas
                    GraficoBarra(
                        :dados='dadosNaoConformidades',
                        :key='idGrafico'
                    )

            el-tab-pane
                span.bloco-tabs-dimensao-menu(slot='label')
                    el-tooltip(
                        effect='dark',
                        placement='right',
                        content='Regularização'
                    )
                        i.lyra-icon.lyra-balanca.balanca-dimensao

                .bloco-tabs-conteudo
                    h2 Pessoas
                    GraficoBarra(:dados='dadosRegularizacao', :key='idGrafico')

            el-tab-pane
                span.bloco-tabs-dimensao-menu(slot='label')
                    el-tooltip(
                        effect='dark',
                        placement='right',
                        content='Potencial de PSA'
                    )
                        i.lyra-icon.lyra-folha-valor

                .bloco-tabs-conteudo
                    h2 Pessoas
                    GraficoBarra(:dados='dadosPotencialPSA', :key='idGrafico')

            el-tab-pane
                span.bloco-tabs-dimensao-menu(slot='label')
                    el-tooltip(
                        effect='dark',
                        placement='right',
                        content='Ativos ambientais'
                    )
                        i.lyra-icon.folha-listrada

                .bloco-tabs-conteudo
                    h2 Pessoas
                    GraficoBarra(
                        :dados='dadosAtivosAmbientais',
                        :key='idGrafico'
                    )

    .bloco-mapa
        Mapa(
            height='100%',
            idMapa='mapaMonitoramentoAgricola',
            :key='keyMapa',
            :mapLayersConfigs='camadasMapa',
            :mapConfig='configuracoesMapa',
            :camadaCentralizadaNome='camadaCentralizadaNome'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet';
import GraficoBarra from '@/components/charts/GraficoBarra';

export default {
    name: 'RankingCategoria',
    components: {
        Mapa,
        GraficoBarra
    },
    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: true,
                diagnostico: true
            },
            keyMapa: 1,
            idGrafico: 1,
            camadaCentralizadaNome: null,
            dadosImoveis: [
                ['Proprietario', 'Área de vegetação nativa (ha)'],
                ['Leandro', 8175000],
                ['New York City, NY', 8175000],
                ['Los Angeles, CA', 3792000],
                ['Chicago, IL', 2695000],
                ['Houston, TX', 2099000],
                ['Philadelphia, PA', 1526000],
                ['New York City, NY', 8175000],
                ['Los Angeles, CA', 3792000],
                ['Chicago, IL', 2695000],
                ['Houston, TX', 2099000],
                ['Philadelphia, PA', 1526000]
            ],
            dadosNaoConformidades: [
                ['Proprietario', 'Área de vegetação nativa (ha)'],
                ['Várzea G', 8175000],
                ['Leandro', 8175000],
                ['Leandro', 8175000],
                ['New York City, NY', 8175000],
                ['Los Angeles, CA', 3792000],
                ['Chicago, IL', 2695000],
                ['Houston, TX', 2099000],
                ['Philadelphia, PA', 1526000],
                ['New York City, NY', 8175000],
                ['Los Angeles, CA', 3792000],
                ['Chicago, IL', 2695000],
                ['Houston, TX', 2099000],
                ['Philadelphia, PA', 1526000]
            ],
            dadosRegularizacao: [
                ['Proprietario', 'Área de vegetação nativa (ha)'],
                ['Várzea G', 8175000],
                ['Leandro', 8175000],
                ['Leandro', 8175000]
            ],
            dadosPotencialPSA: [
                ['Proprietario', 'Área de vegetação nativa (ha)'],
                ['Várzea G', 8175000]
            ],
            dadosAtivosAmbientais: [
                ['Proprietario', 'Área de vegetação nativa (ha)'],
                ['Várzea G', 8175000],
                ['Leandro', 8175000],
                ['Leandro', 8175000],
                ['New York City, NY', 8175000],
                ['Los Angeles, CA', 3792000],
                ['Chicago, IL', 2695000],
                ['Houston, TX', 2099000],
                ['Philadelphia, PA', 1526000]
            ]
        };
    },
    methods: {
        tabClick: function () {
            this.idGrafico++;
            this.keyMapa++;
        }
    }
};
</script>

<style lang="scss">
#ranking-categoria {
    display: flex;

    .bloco-tabs {
        width: 45%;
        display: flex;
        order: 0;
        padding-right: 12px;

        .bloco-tabs-dimensao {
            width: 100%;
            height: 100%;

            .bloco-tabs-conteudo {
                width: 100%;
                background: var(--white);
                height: 525px;
                box-shadow: 0px 0px 20px rgb(0 0 0 / 10%);
                border-radius: 5px;
                padding: 10px 15px;

                h2 {
                    font-size: 16px;
                    color: #3b3b3b;
                    font-weight: 600;
                    margin-bottom: 2px;
                    margin-top: 10px;
                }
            }
            .bloco-tabs-dimensao-menu {
                display: flex;
                flex-direction: column;
                font-size: 38px;
                padding: 10px 4px;
                height: 64px;

                .lyra-icon::before {
                    content: '';
                    width: 31px;
                    height: 38px;
                }
                .balanca-dimensao.lyra-icon::before {
                    content: '';
                    width: 38px !important;
                    height: 41px !important;
                }
            }
        }
    }
    .bloco-mapa {
        width: 55%;
        height: 525px;
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        margin-bottom: 14px;
    }

    .el-tabs__item {
        text-align: center !important;
        background: var(--white);
        box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
        border-radius: 5px;
        margin-bottom: 9px;
        font-weight: 600;
        height: 64px;

        .lyra-icon::before {
            background-color: var(--primary);
        }
        i.el-tooltip.mdi.mdi-alert-outline {
            color: var(--primary);
        }

        &.is-active {
            .lyra-icon::before {
                background-color: var(--white) !important;
            }
            i.el-tooltip.mdi.mdi-alert-outline {
                color: var(--white) !important;
            }
        }
    }
    .el-tabs__item.is-active {
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .el-tabs__nav-wrap::after {
        content: '';
        background-color: #e1e1e1 !important;
    }
    .el-tabs__active-bar {
        display: none;
    }
}
</style>
